import type { ZodError } from "zod";

export function parseOptionalJson(value: FormDataEntryValue | null, label: string): unknown {
  const source = typeof value === "string" ? value.trim() : "";
  if (!source) return null;
  try {
    return JSON.parse(source) as unknown;
  } catch {
    throw new Error(`${label} must be valid JSON`);
  }
}

export function formatProfileValidationError(error: ZodError): Error {
  const issue = error.issues[0];
  if (!issue) return new Error("Agent profile is invalid");
  const field = issue.path.length > 0 ? issue.path.join(".") : "profile";
  return new Error(`${field}: ${issue.message}`);
}
